import { gql } from "graphql-request";

export const GET_CATEGORIES = gql`
  query GetCategories(
    $where: categoryFilterInput
    $order: [DynamicSortInput!]
    $pageNo: Int!
    $pageSize: Int!
  ) {
    getcategorys(
      where: $where
      order: $order
      paging: { pageNo: $pageNo, pageSize: $pageSize }
    ) {
      totalCount
      totalPages
      hasNextPage
      hasPreviousPage
      items {
        ItemId
        CreatedDate
        CreatedBy
        LastUpdatedDate
        LastUpdatedBy
        Language
        OrganizationId
        Tags
        DeletedDate
        categoryName
      }
    }
  }
`;

export const INSERT_CATEGORY = gql`
  mutation InsertCategory(
    $categoryName: String!
    $tags: [String]
  ) {
    insertcategory(
      input: {
        categoryName: $categoryName
        Tags: $tags
      }
    ) {
      acknowledged
      totalImpactedData
      itemId
    }
  }
`;

// v4: target rows with the typed `where` argument. The `filter: String` arg is
// deprecated. Kept inline so no generated <Schema>FilterInput name is needed.
export const UPDATE_CATEGORY = gql`
  mutation UpdateCategory($itemId: String!, $categoryName: String!) {
    updatecategory(
      where: { ItemId: { eq: $itemId } }
      input: { categoryName: $categoryName }
    ) {
      acknowledged
      totalImpactedData
      itemId
    }
  }
`;

export const DELETE_CATEGORY = gql`
  mutation DeleteCategory($itemId: String!) {
    deletecategory(
      where: { ItemId: { eq: $itemId } }
      input: { isHardDelete: true }
    ) {
      acknowledged
      totalImpactedData
      itemId
    }
  }
`;
